module.exports = __webpack_public_path__ + "static/media/default-author.8fdd3e27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/_courses/Author/default-author.svg
// module id = 1485
// module chunks = 0